// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transformativeContainer {
  background-color: #fdf1e3;
  padding: 70px 40px 90px;
}

.transformativeHeading {
  color: #172639;
  font-weight: 800;
  font-size: 2.5rem;
  margin-bottom: 16px;
}

.transformativeSubheading {
  color: #6b7280;
  font-size: 1rem;
  line-height: 1.7;
  margin-bottom: 40px;
}

.advantageIcons {
  margin-bottom: 40px;
  row-gap: 24px;
}

.advantageIconCol {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.advantageIconCircle {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background-color: #172639;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 12px;
  transition: background-color 0.3s ease;
}

.advantageIconCircle--active {
  background-color: #eaa637;
}

.advantageIconLabel {
  color: #172639;
  font-weight: 600;
  text-align: center;
  max-width: 140px;
}

.advantageDetailPanel {
  background-color: #172639;
  border-radius: 16px;
  padding: 50px 40px;
  text-align: center;
}

.advantageDetailTitle {
  color: #ffffff;
  font-weight: 500;
  margin-bottom: 20px;
}

.advantageDetailText {
  color: rgba(255, 255, 255, 0.88);
  font-size: 1.05rem;
  line-height: 1.7;
  max-width: 700px;
  margin: 0 auto;
}

@media (max-width: 992px) {
  .transformativeContainer {
    padding: 50px 24px 60px;
  }

  .transformativeHeading {
    font-size: 2.1rem;
  }

  .advantageIconCircle {
    width: 60px;
    height: 60px;
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .transformativeHeading {
    font-size: 1.8rem;
  }

  .transformativeSubheading {
    font-size: 0.9rem;
  }

  .advantageDetailPanel {
    padding: 35px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TransformativeImpact.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".transformativeContainer {\n  background-color: #fdf1e3;\n  padding: 70px 40px 90px;\n}\n\n.transformativeHeading {\n  color: #172639;\n  font-weight: 800;\n  font-size: 2.5rem;\n  margin-bottom: 16px;\n}\n\n.transformativeSubheading {\n  color: #6b7280;\n  font-size: 1rem;\n  line-height: 1.7;\n  margin-bottom: 40px;\n}\n\n.advantageIcons {\n  margin-bottom: 40px;\n  row-gap: 24px;\n}\n\n.advantageIconCol {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n}\n\n.advantageIconCircle {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background-color: #172639;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  margin-bottom: 12px;\n  transition: background-color 0.3s ease;\n}\n\n.advantageIconCircle--active {\n  background-color: #eaa637;\n}\n\n.advantageIconLabel {\n  color: #172639;\n  font-weight: 600;\n  text-align: center;\n  max-width: 140px;\n}\n\n.advantageDetailPanel {\n  background-color: #172639;\n  border-radius: 16px;\n  padding: 50px 40px;\n  text-align: center;\n}\n\n.advantageDetailTitle {\n  color: #ffffff;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n\n.advantageDetailText {\n  color: rgba(255, 255, 255, 0.88);\n  font-size: 1.05rem;\n  line-height: 1.7;\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n@media (max-width: 992px) {\n  .transformativeContainer {\n    padding: 50px 24px 60px;\n  }\n\n  .transformativeHeading {\n    font-size: 2.1rem;\n  }\n\n  .advantageIconCircle {\n    width: 60px;\n    height: 60px;\n    font-size: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .transformativeHeading {\n    font-size: 1.8rem;\n  }\n\n  .transformativeSubheading {\n    font-size: 0.9rem;\n  }\n\n  .advantageDetailPanel {\n    padding: 35px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
